document.addEventListener("DOMContentLoaded", function () {
  // Select all <details> elements
  const detailsElements = document.querySelectorAll("details");
  const header = document.querySelector(".site-header");
  const homepageData = document.getElementById("homepage-data");
  const scrollingEffect = homepageData.getAttribute("data-scrolling-effect");
  // console.log(scrollingEffect);
  // Function to update header background based on <details> elements
  function updateHeaderBackground() {
    let isOpen = false;

    // Check if any <details> element is open
    detailsElements.forEach((details) => {
      if (details.hasAttribute("open")) {
        isOpen = true;
      }
    });

    // Update header background based on whether any <details> is open
    if (isOpen) {
      header.classList.add("sk-menu-open");
    } else {
      header.classList.remove("sk-menu-open");
    }
  }
  // end

  // Initial check
  updateHeaderBackground();

  // Add event listeners to all <details> elements
  detailsElements.forEach((details) => {
    details.addEventListener("toggle", updateHeaderBackground);
  });
  // end

  const scrollThreshold = 10; // Set this to the scroll position where you want to change the background
  function onScroll() {
    if (window.scrollY > scrollThreshold) {
      header.classList.add("sk-scrolled");
    } else {
      header.classList.remove("sk-scrolled");
    }
  }

  // end

  // Add scroll event listener
  // window.addEventListener("scroll", onScroll);

  // Initial check in case of page load with scroll position already set
  //onScroll();

  const blocks = document.querySelectorAll(".hero-block"); // Select all hero blocks
  const sections = document.querySelectorAll(".sk-footer"); // Select all sections

  const allElements = [...blocks, ...sections]; // Combine blocks and sections into one array
  let currentIndex = 0; // Initialize the current index
  const featuredMenu = document.getElementById("sk-featured-menu");
  const featuredMenuContainer = document.getElementById(
    "sk-featured-menu-container"
  );
  const linkElements = featuredMenuContainer.querySelectorAll("a");
  //if (scrollingEffect === "smooth") {
  // Function to scroll to a specific index
  function scrollToElement(index) {
    allElements[index].scrollIntoView({ behavior: "smooth" });
    currentIndex = index; // Update current index
    updateActiveLink(currentIndex); // Update active link
  }
  function scrollToElement2(index) {
    //allElements[index].scrollIntoView({ behavior: "smooth" });
    currentIndex = index; // Update current index
    updateActiveLink(currentIndex); // Update active link
  }
  //}
  // Function to check which element is currently in view
  function updateCurrentIndexOnLoad() {
    const scrollPosition = window.scrollY + window.innerHeight / 2; // Middle of the viewport
    allElements.forEach((element, index) => {
      const elementTop = element.offsetTop;
      const elementBottom = elementTop + element.offsetHeight;

      // If the middle of the viewport is within this element
      if (scrollPosition >= elementTop && scrollPosition < elementBottom) {
        currentIndex = index; // Set current index
        updateActiveLink(currentIndex); // Update active link
        //console.log(currentIndex + " activated");
        if (
          currentIndex === 0 ||
          currentIndex === 1 ||
          currentIndex === allElements.length - 1
        ) {
          featuredMenu.style.opacity = "0";
        } else {
          featuredMenu.style.opacity = "1";
          featuredMenu.style.display = "flex";
        }
      }
    });

    // Set opacity based on currentIndex
    if (
      currentIndex === 0 ||
      currentIndex === 1 ||
      currentIndex === allElements.length - 1
    ) {
      featuredMenu.style.opacity = "0"; // Hide the menu at the start and end
      //console.log("menu is hidden at index " + currentIndex);
    } else {
      featuredMenu.style.opacity = "1"; // Show the menu in other cases
    }
  }

  // Add click event listeners to each link
  linkElements.forEach((link, index) => {
    link.addEventListener("click", (event) => {
      //event.preventDefault(); // Prevent default anchor click behavior
      scrollToElement(index); // Scroll to the corresponding element
      if (index === 0 || index === 1) {
        featuredMenu.classList.add("d-none");
      } else {
        featuredMenu.classList.remove("d-none");
      }
    });
  });

  // Add scroll event listener for mouse wheel
  if (scrollingEffect === "smooth") {
    window.addEventListener(
      "wheel",
      (event) => {
        event.preventDefault(); // Always prevent default scroll behavior

        const delta = event.deltaY; // Get scroll delta

        // Adjust scroll sensitivity threshold (if needed)
        const threshold = 10; // Change this value to adjust scroll sensitivity

        // If scrolling down
        if (delta > threshold) {
          if (currentIndex < allElements.length - 1) {
            currentIndex++; // Move to the next element
            scrollToElement(currentIndex); // Scroll to the next element
          }
        }
        // If scrolling up
        else if (delta < -threshold) {
          if (currentIndex > 0) {
            currentIndex--; // Move to the previous element
            scrollToElement(currentIndex); // Scroll to the previous element
          }
        }

        // Adjust opacity based on currentIndex
        if (
          currentIndex === 0 ||
          currentIndex === 1 ||
          currentIndex === allElements.length - 1
        ) {
          featuredMenu.style.opacity = "0";
          // Wait for the opacity transition to finish, then hide the element
          setTimeout(() => {
            if (featuredMenu.style.opacity === "0") {
              featuredMenu.style.display = "none"; // Set display to none after opacity transition
            }
          }, 300); // Timeout matches the CSS transition duration (300ms
        } else {
          // Show the menu by resetting the display and then adjusting opacity
          featuredMenu.style.display = "flex";
          setTimeout(() => {
            featuredMenu.style.opacity = "1";
          }, 10);
        }
      },
      { passive: false } // Prevents the browser from handling the scroll event by default
    );
  } else {
    // Normal Scrolling Mode (uses scroll instead of wheel)
    window.addEventListener(
      "scroll",
      () => {
        let foundIndex = -1;
        allElements.forEach((element, index) => {
          let rect = element.getBoundingClientRect();
          let windowHeight = window.innerHeight;

          // Detect the element that is 50% from the bottom
          if (
            rect.bottom <= windowHeight * 1.5 &&
            rect.bottom > windowHeight * 0.5
          ) {
            foundIndex = index;
            updateActiveLink(foundIndex);
          }
        });

        if (foundIndex !== -1) {
          currentIndex = foundIndex; // Update index when a section is visible
          //console.log("Updated currentIndex: ", currentIndex);
        }

        // Show menu when the section is 50% from bottom
        toggleFeaturedMenu();
      },
      { passive: true }
    );
  }

  // Function to adjust menu visibility
  function toggleFeaturedMenu() {
    if (
      currentIndex === 0 ||
      currentIndex === 1 ||
      currentIndex === allElements.length - 1
    ) {
      featuredMenu.style.opacity = "0";
      setTimeout(() => {
        if (featuredMenu.style.opacity === "0") {
          featuredMenu.style.display = "none";
        }
      }, 300);
    } else {
      featuredMenu.style.display = "flex";
      setTimeout(() => {
        featuredMenu.style.opacity = "1";
      }, 10);
    }
  }

  // Add touch events for mobile devices
  window.addEventListener("touchstart", (event) => {
    startY = event.touches[0].clientY; // Get the start Y position
  });

  window.addEventListener("touchmove", (event) => {
    endY = event.touches[0].clientY; // Update the end Y position
  });

  window.addEventListener("touchend", () => {
    const deltaY = startY - endY; // Calculate the vertical movement

    // If swiping down
    if (deltaY > 50) {
      if (currentIndex < allElements.length - 1) {
        currentIndex++; // Move to the next element
        scrollToElement(currentIndex); // Scroll to the next element
      }
    }
    // If swiping up
    else if (deltaY < -50) {
      if (currentIndex > 0) {
        currentIndex--; // Move to the previous element
        scrollToElement(currentIndex); // Scroll to the previous element
      }
    }

    // Adjust opacity based on currentIndex
    if (currentIndex === 0 || currentIndex === allElements.length - 1) {
      featuredMenu.style.opacity = "0";
      setTimeout(() => {
        if (featuredMenu.style.opacity === "0") {
          featuredMenu.style.display = "none";
        }
      }, 300);
    } else {
      featuredMenu.style.display = "flex";
      setTimeout(() => {
        featuredMenu.style.opacity = "1";
      }, 10);
    }
  });

  // Function to update the active class on links
  function updateActiveLink(index) {
    const shopNowElement = document.getElementById("shopnow");
    //console.log("active link " + index);
    linkElements.forEach((link, i) => {
      // Add 'active' class to the current link and remove from others
      if (i === index) {
        link.classList.add("active");
        const url = link.getAttribute("data-url");
        if (url) {
          shopNowElement.setAttribute("href", url);
        }
      } else {
        link.classList.remove("active");
      }
    });
  }
  window.addEventListener("load", updateCurrentIndexOnLoad);

  // Get all the offcanvas toggles
  // const offcanvasToggles = document.querySelectorAll(".sk-menu-item");
  const offcanvasToggles = document.querySelectorAll(
    '.sk-menu-item[data-bs-toggle="offcanvas"]'
  );
  //console.log(offcanvasToggles.length);
  // Keep track of the currently active toggle
  let activeToggle = null;

  var offcanvasElements = [
    document.getElementById("collections"),
    document.getElementById("news"),
    document.getElementById("lookbook"),
    document.getElementById("shopcategory"),
  ];

  var headerElement = document.querySelector(".site-header");
  // Add mouseleave event to hide the offcanvas only if mouse is not over the offcanvas content
  headerElement.addEventListener("mouseleave", function () {
    setTimeout(() => {
      // Check if both the toggle and the offcanvas are not hovered
      if (!headerElement.matches(":hover")) {
        //headerElement.classList.remove("sk-menu-open");
      }
    }, 200);
  });

  // Initialize Bootstrap offcanvas instances for manual control
  const offcanvasInstances = offcanvasElements.map(function (offcanvasElement) {
    return new bootstrap.Offcanvas(offcanvasElement);
  });

  // Function to show offcanvas
  function showOffcanvas(offcanvasElement) {
    const offcanvasInstance = bootstrap.Offcanvas.getInstance(offcanvasElement);
    if (offcanvasInstance) {
      offcanvasInstance.show();
      // Add 'sk-menu-open' class to header when offcanvas is shown
      headerElement.classList.add("sk-menu-open");
    }
  }

  // Function to hide offcanvas
  function hideOffcanvas(offcanvasElement) {
    const offcanvasInstance = bootstrap.Offcanvas.getInstance(offcanvasElement);
    if (offcanvasInstance) {
      offcanvasInstance.hide();
      //console.log("hide");
      // Remove 'sk-menu-open' class from header when offcanvas is hidden
      //headerElement.classList.remove("sk-menu-open");
    }
  }

  // Add hover event to show/hide offcanvas on hover for toggles
  offcanvasToggles.forEach(function (toggle) {
    const offcanvasTargetId = toggle.getAttribute("data-bs-target");
    const offcanvasElement = document.querySelector(offcanvasTargetId);

    // On mouseenter (hover) show the offcanvas
    toggle.addEventListener("mouseenter", function () {
      showOffcanvas(offcanvasElement);
      //console.log(toggle.id + "activated");

      // Remove 'active' class from previously active toggle
      if (activeToggle && activeToggle !== toggle) {
        activeToggle.classList.remove("active");
      }

      // Add 'active' class to the current toggle
      toggle.classList.add("active");
      activeToggle = toggle; // Keep track of the active toggle
    });

    // Add mouseleave event to hide the offcanvas only if mouse is not over the offcanvas content
    toggle.addEventListener("mouseleave", function () {
      setTimeout(() => {
        // Check if both the toggle and the offcanvas are not hovered
        if (!offcanvasElement.matches(":hover") && !toggle.matches(":hover")) {
          hideOffcanvas(offcanvasElement);
          //headerElement.classList.remove("sk-menu-open");
          toggle.classList.remove("active"); // Remove 'active' class when offcanvas is hidden
        }
      }, 100);
    });
  });

  // Add hover event to prevent hiding offcanvas when hovering over the offcanvas content
  offcanvasElements.forEach(function (offcanvasElement) {
    offcanvasElement.addEventListener("mouseenter", function () {
      // Keep it open
      headerElement.classList.add("sk-menu-open");
      showOffcanvas(offcanvasElement);
    });

    // On mouseleave, hide the offcanvas if not hovering over the toggle anymore
    offcanvasElement.addEventListener("mouseleave", function () {
      setTimeout(() => {
        const toggle = document.querySelector(
          `[data-bs-target="#${offcanvasElement.id}"]`
        );
        if (!offcanvasElement.matches(":hover") || !toggle.matches(":hover")) {
          hideOffcanvas(offcanvasElement);
          headerElement.classList.remove("sk-menu-open");

          if (toggle) toggle.classList.remove("active"); // Remove 'active' class on hide
        }
      }, 100);
    });
  });

  // Get all collection links
  const smls = document.querySelectorAll(".sk-menu-link");

  // Add hover event to each link
  smls.forEach((link) => {
    link.addEventListener("mouseenter", function () {
      const imgSrc = this.getAttribute("data-img");

      // Find the closest parent with class 'offcanvas', then find the image inside it
      const offcanvas = this.closest(".offcanvas");
      const imageElement = offcanvas.querySelector(".the-image");

      // Ensure the corresponding image element exists
      if (imageElement) {
        imageElement.setAttribute("src", imgSrc);
        imageElement.style.opacity = 1;
        imageElement.style.transition = "all 300ms ease-in-out";
      }
    });

    link.addEventListener("mouseleave", function () {
      // Find the closest parent with class 'offcanvas', then find the image inside it
      const offcanvas = this.closest(".offcanvas");
      const imageElement = offcanvas.querySelector(".the-image");

      if (imageElement) {
        imageElement.style.opacity = 0;
      }
    });
  });
  //end
});
